<template>
  <component :is="component" v-bind="{ ...$attrs, ...$props }"></component>
</template>

<script>
import yuanLinKongZhiQi23 from "./yuanLinKongZhiQi23/rtuFmList.vue"
import yuanLinKongZhiQi24 from "./yuanLinKongZhiQi24/rtuFmList.vue"

export default {
  components: { yuanLinKongZhiQi23, yuanLinKongZhiQi24 },
  props: ['type'],
  data () {
    return {
      component: null
    }
  },

  watch: {
    async hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem('no')
        this.no = no
        this.renderComponent()
      }
    },

  },

  mounted () {
    this.renderComponent()
  },


  methods: {
    renderComponent () {
      console.log("园林控制器类的轮灌组 根据type挂载不同的组件:", this.$props, this.$attrs);
      if (this.type == 23) {
        this.component = yuanLinKongZhiQi23
      } else {
        this.component = yuanLinKongZhiQi24
      }
    }
  }
}
</script>

<style></style>
